import ActivityCalculator from '@/components/ActivityCalculator';
import { lazy } from 'react';

// Lazy load all page components for better performance
export const ROUTE_COMPONENTS = {
  ActivityDetailPage: lazy(() => import("../pages/ActivityDetailPage")),
  TaskDetailPage: lazy(() => import("../pages/TaskDetailPage")),


  DISCTestPage: lazy(() => import("../pages/DISCTest")),
  
  
  LogActivityPage: lazy(() => import("../pages/LogActivityPage")),
  ActivityFeedPage: lazy(() => import("../pages/ActivityFeedPage")),
  NotesTasksPage: lazy(() => import("../pages/NotesTasksPage")),
  PetPage: lazy(() => import("../pages/PetPage")),
  ClubPage: lazy(() => import("../pages/ClubPage")),
  StatsPage: lazy(() => import("../pages/StatsPage")),
  RedemptionPage: lazy(() => import("../pages/RedemptionPage")),
  AdminPage: lazy(() => import("../pages/AdminPage")),
  TrackerAdminPage: lazy(() => import("../pages/TrackerAdminPage")),
  AttendancePage: lazy(() => import("../pages/AttendancePage")),
  AttendanceAdminPage: lazy(() => import("../pages/AttendanceAdminPage")),
  AttendanceAnalyticsPage: lazy(() => import("../pages/AttendanceAnalyticsPage")),
  EventRegistrationPage: lazy(() => import("../pages/EventRegistrationPage")),
  EventsWithSidebarPage: lazy(() => import("../pages/EventsWithSidebarPage")),
  SalesResourcesPage: lazy(() => import("../pages/SalesResourcesPage")),
  ManagerToolsPage: lazy(() => import("../pages/ManagerToolsPage")),
  ConsultantToolsPage: lazy(() => import("../pages/ConsultantToolsPage")),
  AiaLinksPage: lazy(() => import("../pages/AiaLinksPage")),
  ResourcesHubPage: lazy(() => import("../pages/ResourcesHubPage")),
  EventsPublicPage: lazy(() => import("../pages/EventsPublicPage")),
  AttendanceTrackerLandingPage: lazy(() => import("../pages/AttendanceTrackerLandingPage")),
  LeaveRequestsPage: lazy(() => import("../pages/LeaveRequestsPage")),
  
  WeeklyReflectionsPage: lazy(() => import("../pages/WeeklyReflectionsPage")),
  UserActivityBreakdownPage: lazy(() => import("../pages/UserActivityBreakdownPage")),
  Feedback: lazy(() => import("../pages/Feedback")),
  InsuranceCalculatorPage: lazy(() => import("../pages/InsuranceCalculatorPage")),
  PledgeCalculatorPage: lazy(() => import("../pages/PledgeCalculatorPage")),
  ActivityCalculator: lazy(() => import("../pages/ActivityCalculator")),
  CoachingPage: lazy(() => import("../pages/CoachingPage")),
  CoachingSettings: lazy(() => import("../pages/CoachingSettings")),
  BookingConfirmation: lazy(() => import("../pages/BookingConfirmation")),
  EventDetailPage: lazy(() => import("../pages/EventDetailPage")),
  EventAnalyticsDetailPage: lazy(() => import("../pages/EventAnalyticsDetailPage")),
  PublicCalendarPage: lazy(() => import("../pages/PublicCalendarPage")),
  EventSharePage: lazy(() => import("../pages/EventSharePage")),
  CreateEventPage: lazy(() => import("../pages/CreateEventPage")),
  AttendanceCheckInRedirect: lazy(() => import("../pages/AttendanceCheckInRedirect")),
  MegaAppHome: lazy(() => import("../components/mega-app/MegaAppHome"))
} as const;

export interface RouteConfig {
  path: string;
  element?: keyof typeof ROUTE_COMPONENTS;
  protected?: boolean;
  redirectTo?: string;
}

export const ROUTE_CONFIGS: RouteConfig[] = [
  // New URL structure
  { path: "/tracker/log", element: "LogActivityPage", protected: true },
  { path: "/tracker/feed", element: "ActivityFeedPage", protected: true },
  { path: "/tracker/pet", element: "PetPage", protected: true },
  { path: "/tracker/redeem", element: "RedemptionPage", protected: true },
  { path: "/tracker/reflections", element: "WeeklyReflectionsPage", protected: true },
  { path: "/tracker/club", element: "ClubPage", protected: true },
  { path: "/tracker/pledge-calculator", element: "PledgeCalculatorPage", protected: true },
  
  // Tracker Admin routes
  { path: "/tracker/admin/consultants", element: "TrackerAdminPage", protected: true },
  { path: "/tracker/admin/analytics", element: "TrackerAdminPage", protected: true },
  { path: "/tracker/admin/goals", element: "TrackerAdminPage", protected: true },
  { path: "/tracker/admin/rewards", element: "TrackerAdminPage", protected: true },
  { path: "/tracker/admin/user-approval", element: "TrackerAdminPage", protected: true },
  { path: "/tracker/admin/apps", element: "TrackerAdminPage", protected: true },
  { path: "/tracker/admin/settings", element: "TrackerAdminPage", protected: true },
  { path: "/tracker/admin", redirectTo: "/tracker/admin/consultants" },
  
  { path: "/tracker/stats", redirectTo: "/tracker/redeem" },
  { path: "/admin", redirectTo: "/tracker/admin" },
  { path: "/feedback", element: "Feedback", protected: true },
  { path: "/income-calculator", element: "InsuranceCalculatorPage", protected: true },
  { path: "/coaching", element: "CoachingSettings", protected: true },
  
  // Attendance routes
  { path: "/attendance/:tab", element: "AttendancePage", protected: true },
  { path: "/attendance", redirectTo: "/attendance/proximity" },
  { path: "/attendance/leave-requests", element: "LeaveRequestsPage", protected: true },
  { path: "/attendance/leave-request/new", redirectTo: "/attendance/leave-requests" },
  
  // Admin attendance routes
  { path: "/attendance/admin/analytics", element: "AttendanceAdminPage", protected: true },
  { path: "/attendance/admin/analytics/by-event", element: "AttendanceAdminPage", protected: true },
  { path: "/attendance/admin/analytics/by-user", element: "AttendanceAdminPage", protected: true },
  { path: "/attendance/admin/leave-requests", element: "AttendanceAdminPage", protected: true },
  { path: "/attendance/admin/qr-code", element: "AttendanceAdminPage", protected: true },
  { path: "/attendance/admin/settings", element: "AttendanceAdminPage", protected: true },
  { path: "/attendance/admin/:tab", element: "AttendanceAdminPage", protected: true },
  { path: "/attendance/admin", element: "AttendanceAdminPage", protected: true },
  { path: "/attendance/admin/analytics/:tab", element: "AttendanceAnalyticsPage", protected: true },
  { path: "/attendance/admin/analytics", redirectTo: "/attendance/admin/analytics/by-event" },
  
  // User and activity detail pages
  { path: "/tracker/user-breakdown/:userId", element: "UserActivityBreakdownPage", protected: true },
  { path: "/activity/:id", element: "ActivityDetailPage", protected: true },
  { path: "/task/:type/:id", element: "TaskDetailPage", protected: true },
  { path: "/admin/event-analytics/:eventId", element: "EventAnalyticsDetailPage", protected: true },
  
  // Public routes
  { path: "/events", element: "EventsWithSidebarPage" },
  { path: "/events-public", element: "EventsPublicPage" },
  { path: "/calendar", element: "PublicCalendarPage" },
  { path: "/create-event", element: "CreateEventPage" },
  { path: "/attendance-checkin", element: "AttendanceCheckInRedirect" },
  { path: "/event/share/:shareSlug", element: "EventSharePage" },
  { path: "/event/:eventId", element: "EventDetailPage" },
  { path: "/coaching/:slug", element: "CoachingPage" },
  { path: "/booking-confirmation/:bookingId", element: "BookingConfirmation" },
  
  // Backward compatibility redirects
  { path: "/dashboard/log", redirectTo: "/tracker/log" },
  { path: "/dashboard/feed", redirectTo: "/tracker/feed" },
  { path: "/dashboard/pet", redirectTo: "/tracker/pet" },
  { path: "/dashboard/redeem", redirectTo: "/tracker/redeem" },
  { path: "/dashboard/stats", redirectTo: "/tracker/redeem" },
  { path: "/dashboard/reflections", redirectTo: "/tracker/reflections" },
  { path: "/dashboard/club", redirectTo: "/tracker/club" },
  { path: "/dashboard/pledge-calculator", redirectTo: "/tracker/pledge-calculator" },
  { path: "/dashboard/admin", redirectTo: "/admin" },
  { path: "/dashboard/feedback", redirectTo: "/feedback" },
  { path: "/dashboard/insurance-calculator", redirectTo: "/income-calculator" },
  { path: "/dashboard/coaching-settings", redirectTo: "/coaching" },
  { path: "/dashboard/leave-requests", redirectTo: "/attendance/leave-requests" },
  { path: "/dashboard/user-breakdown/:userId", redirectTo: "/tracker/user-breakdown/:userId" },
  { path: "/dashboard", redirectTo: "/tracker/log" },
  
  // Attendance backward compatibility redirects
  { path: "/dashboard/attendance", redirectTo: "/attendance" },
  { path: "/dashboard/attendance/:tab", redirectTo: "/attendance/:tab" }
];